<template>
    <div>
        <div
            @click="shownow"
            class="new_bot flex justify-center align-center pointer"
        >
            <div class="bot_text">{{ text }}</div>
            <div class="bot_btn">联系我们</div>
        </div>
        <el-dialog title="联系电话" :visible.sync="addcompany">
            <div class="phone-dialog">
                <el-form style="text-align: left; font-size: 18px">
                    <el-form-item
                        label="联系电话:"
                        :label-width="formLabelWidth"
                        style="font-size: 18px"
                    >
                        <div class="flex align-center">
                            <div style="flex: 1; font-size: 18px">
                                {{ config.phone }}
                            </div>
                            <!-- <el-button @click="tosub" type="primary" style="height:30px;padding:0px 15px;" >复制</el-button> -->
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <!-- <el-dialog title="咨询" :visible.sync="addcompany" >
            <div class="" style="text-align: center;margin: 0 auto;">
                <el-form :model="cominfo" style="text-align:center;">
                    <el-form-item label="姓名" :label-width="formLabelWidth">
                        <el-input style="width: 100%;" placeholder="请输入" v-model="cominfo.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" :label-width="formLabelWidth">
                        <el-input style="width: 100%;" placeholder="请输入" v-model="cominfo.phone" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="咨询内容" :label-width="formLabelWidth">
                        <el-input type="textarea" :rows="2" style="width: 100%;" placeholder="请输入咨询内容" v-model="cominfo.content" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="flex justify-center align-center">
                <el-button :disabled="nowdisabled" @click="tosub" type="primary">提 交</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "call-view",
    props: {
        text: {
            type: String,
            default: "",
        },
    },
    computed: {
        ...mapGetters(["userinfo", "token", "config"]),
    },
    data() {
        return {
            addcompany: false,
            cominfo: {
                question_id: "",
                type: 5,
                company_name: "",
                name: "",
                phone: "",
                content: "",
                user_id: "",
            },
            nowdisabled: false,
            formLabelWidth: "120px",
        };
    },
    methods: {
        shownow() {
            if (!this.token) {
                this.$message.error("请登录");
                return false;
            }
            this.addcompany = true;
            // this.cominfo.question_id = this.detail.id;
        },
        tosub() {
            // question_add
            console.log(this.cominfo);
            if (
                !this.cominfo.content ||
                !this.cominfo.phone ||
                !this.cominfo.name
            ) {
                this.$message({
                    message: "请完善信息",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            if (!this.cominfo.phone) {
                this.$message({
                    message: "请输入手机号",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            if (!/^1[3456789]\d{9}$/.test(this.cominfo.phone)) {
                this.$message({
                    message: "手机号码错误！",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            this.cominfo.user_id = this.token;
            this.nowdisabled = true;
            this.$api.index
                .question_add(this.cominfo)
                .then((res) => {
                    console.log(res);
                    this.$message({
                        message: res.msg,
                        type: "none",
                        duration: 1000,
                    });
                    this.addcompany = false;
                    this.cominfo.phone = "";
                    this.cominfo.name = "";
                    this.cominfo.content = "";
                    this.nowdisabled = false;
                })
                .catch(() => {
                    this.nowdisabled = false;
                });
        },
    },
    created() {},
};
</script>

<style>
.phone-dialog .el-form-item__label {
    font-size: 18px;
}
</style>
 
<style scoped>
.sd_title {
    text-align: center;
    border-bottom: 1px solid #eee;
}

.biaoti1 {
    font-size: 32px;
    color: #202020;
    line-height: 42px;
}

.bt_mes {
    font-size: 15px;
    color: #7f7f7f;
    line-height: 35px;
    margin-bottom: 20px;
}
.filecolor {
    text-decoration: none;
    margin: 5px 0;
    background: #fff;
    border: none;
}

.new_bot {
    width: 100%;
    height: 70px;
    background-image: linear-gradient(
        0deg,
        #1759d8 0%,
        #107ee4 56%,
        #08a3f0 100%
    );
    /* margin-top: 30px; */
}
.bot_text {
    color: #ffffff;
    font-size: 22px;
}
.bot_btn {
    width: 144px;
    height: 44px;
    background-image: linear-gradient(0deg, #ece2ae 0%, #fffef4 100%);
    border-radius: 22px;
    color: #b97a00;
    line-height: 44px;
    font-size: 20px;
    text-align: center;
    margin-left: 50px;
}
</style>


// WEBPACK FOOTER //
// call-view.vue?30603e71